// extracted by mini-css-extract-plugin
export default {"addToCartControl":"J2-z","giftCard":"K2-z","btnContainer":"L2-z","cartButton":"M2-z","disabled":"N2-z","stockMessage":"O2-z"};